import { render, staticRenderFns } from "./filter_summary.vue?vue&type=template&id=3b5595e8&scoped=true&lang=html&"
import script from "./filter_summary.vue?vue&type=script&lang=js&"
export * from "./filter_summary.vue?vue&type=script&lang=js&"
import style0 from "./filter_summary.vue?vue&type=style&index=0&id=3b5595e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5595e8",
  null
  
)

export default component.exports